import Overview from '@/rebuild/materials/shared/finance_data/FullIndex.vue';
import MobOverview from '@/rebuild/materials/shared/finance_data/MobOverview.vue';
import MobFull from '@/rebuild/materials/shared/finance_data/MobFull.vue';

export const componentMap = {
	overview: Overview,
	'mob-overview': MobOverview,
	'mob-full': MobFull
};
